module.exports = __webpack_public_path__ + "static/media/history_15.5d86a421.jpg";